import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useToast } from "./ToastContext";
import productData from "../Datas/productData";
import "../css/tracking-order.scss";

const TrackingOrder = () => {
  const [orderNumber, setOrderNumber] = useState("");
  const [searchedOrder, setSearchedOrder] = useState(null);
  const { showToast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    const queryId = orderNumber.trim();
    if (queryId) {
      // Check if order exists in localStorage
      const savedOrders = JSON.parse(localStorage.getItem("myOrders") || "[]");
      const foundOrder = savedOrders.find((order) => order.id === queryId);

      if (foundOrder) {
        setSearchedOrder(foundOrder);
      } else {
        setSearchedOrder(null);
        showToast("Order not found. Please check your order number.", "error");
      }
    }
  };

  const getStatusLabel = (status) => {
    const statusMap = {
      pending: "Pending Payment",
      processing: "Processing",
      shipped: "Shipped",
      completed: "Completed",
    };
    return statusMap[status] || status;
  };

  const getStatusClass = (status) => {
    const classMap = {
      pending: "status--pending",
      processing: "status--processing",
      shipped: "status--shipped",
      completed: "status--completed",
    };
    return classMap[status] || "";
  };

  const isVideo = (url) => /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  let orderProducts = [];
  if (searchedOrder) {
    orderProducts = searchedOrder.items
      .map((item) => {
        const product = productData.find(
          (p) => p.id === parseInt(item.productId)
        );
        return product ? { ...product, ...item } : null;
      })
      .filter(Boolean);
  }

  return (
    <div className="tracking-order-page color-scheme color-scheme--scheme-1">
      <Header />
      <main className="tracking-order-page__main">
        <div className="tracking-order-container">
          <h1 className="tracking-order-title">Tracking Order</h1>

          <form className="tracking-order-form" onSubmit={handleSubmit}>
            <input
              type="text"
              className="tracking-order-input"
              placeholder="Order Number"
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
              required
            />
            <button type="submit" className="tracking-order-submit">
              SUBMIT
            </button>
          </form>

          {searchedOrder && (
            <div className="searched-order-result">
              <div className="order-card">
                <div className="order-card__header">
                  <span className="order-id">Order #{searchedOrder.id}</span>
                  <span
                    className={`order-status ${getStatusClass(
                      searchedOrder.status
                    )}`}
                  >
                    {getStatusLabel(searchedOrder.status)}
                  </span>
                </div>

                <div className="order-card__products">
                  {orderProducts.map((product) => (
                    <Link
                      key={product.id}
                      to={`/orderDetail/${searchedOrder.id}`}
                      className="order-product"
                      onClick={toTop}
                    >
                      <div className="order-product__image">
                        {isVideo(product.images[0]) ? (
                          <video
                            src={product.images[0]}
                            autoPlay
                            muted
                            loop
                            playsInline
                          />
                        ) : (
                          <img src={product.images[0]} alt={product.name} />
                        )}
                      </div>
                      <div className="order-product__info">
                        <p className="order-product__name">{product.name}</p>
                        <p className="order-product__meta">
                          Size: {product.size} × {product.quantity}
                        </p>
                      </div>
                    </Link>
                  ))}
                </div>

                <div className="order-card__footer">
                  <span className="order-date">{searchedOrder.date}</span>
                  <div className="order-total">
                    <span>Total:</span>
                    <span className="total-amount">
                      € {Number(searchedOrder.total).toFixed(2)}
                    </span>
                  </div>
                </div>

                <div className="order-card__actions">
                  <Link
                    to={`/orderDetail/${searchedOrder.id}`}
                    className="action-btn action-btn--outline"
                    onClick={toTop}
                  >
                    Order Details
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TrackingOrder;
